import { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import ReactFlagsSelect from 'react-flags-select';
import { gameProviderTypes } from '@configs/layout';
import { Countries2DigitCode } from '@models/commonModel';
import { fetchInsightData } from '@reducers/keyword/thunk/insightThunk';
import { setParams, setKeywordList } from '@reducers/keyword/keywordInsightSlice';
import { CommonUtil } from '@utils/common/common';
import { setLocaleValue, getLocaleValueForFlag } from '@utils/common/language';

const SearchAppComponent = () => {
  const dispatch = useDispatch<AppDispatch>();

  // const { params } = useSelector(({ keywordSuggestion }: RootState) => keywordSuggestion);
  const { myAppObj, comptitorApps } = useSelector(({ LAYOUT }: RootState) => LAYOUT);

  const [searchText, setSearchText] = useState('');
  const [searchResultList, setSearchResultList] = useState([]);

  const countriesArr = Countries2DigitCode.map((item) => item.code);
  const [searchListFlag, setSearchListFlag] = useState(false);
  const [selectedAppList, setSelectedAppList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(getLocaleValueForFlag());

  useEffect(() => {
    if (selectedAppList.length === 0) {
      // 일단 [] 의길이가 0일때만 그리드 데이터 초기화 처리
      dispatch(setKeywordList({}));
    }
  }, [selectedAppList]);

  // useEffect for appSearch List 요청
  useEffect(() => {
    if (searchText.trim().length > 0) {
      CommonUtil.debounceRequest({
        params: { searchText: searchText, country: selectedCountry },
        requestMethod: 'GET',
        url: '/api/appSearchResultList.json',
        setState: (data) => setSearchResultList(data),
      });
    }
  }, [searchText]);

  const onChangeSearchTextHandler = useCallback((event) => {
    const { value } = event.target;
    setSearchText(value);
  }, []);

  const onFocusSearchTexthandler = useCallback(() => {
    // 현재 searchText 가 빈값이면 기존에 등록된 내앱 / 경쟁앱 이 리스트로 떠야한다.
    if (searchText.trim().length === 0) {
      let resultList = [];
      resultList.push(CommonUtil.objectGenerator('myApp', 'My App'));
      resultList.push(myAppObj ? myAppObj : CommonUtil.objectGenerator('myApp', ''));
      resultList.push(CommonUtil.objectGenerator('competitorApps', 'Competitor Apps'));
      if (!!comptitorApps && comptitorApps?.length > 0) {
        comptitorApps.forEach((appObj) => {
          resultList.push(appObj);
        });
      } else {
        resultList.push(CommonUtil.objectGenerator('competitorApps', ''));
      }

      setSearchResultList(resultList);
    }
    setSearchListFlag(true);
  }, [searchText, myAppObj, comptitorApps]);

  const onBlurSearchTexthandler = useCallback(() => {
    setSearchListFlag(false);
  }, []);

  // listonClickHandler
  const onClickAppListHandler = useCallback(
    (selectedObj) => {
      if (![' ', 'My App', 'Competitor Apps', ''].includes(selectedObj.value)) {
        if (
          selectedAppList.findIndex((appObj) => {
            return appObj.appId === selectedObj.appId && appObj.type === selectedObj.type;
          }) === -1
        ) {
          setSelectedAppList((prev) => {
            let temp = prev.concat(selectedObj);
            return temp;
          });
        } else {
          setSelectedAppList((prev) =>
            prev.filter((item) => {
              return item.appId === selectedObj.appId && item.type === selectedObj.type ? false : true;
            })
          );
        }
      }
    },
    [selectedAppList]
  );

  // listDel
  const onClickAppListDelHandler = useCallback(
    (selectedObj) => {
      setSelectedAppList((prev) =>
        prev.filter((item) => {
          return item.appId === selectedObj.appId && item.type === selectedObj.type ? false : true;
        })
      );
    },
    [selectedAppList]
  );

  const onChangeSelectCountry = useCallback((code) => {
    setSelectedCountry(code);
  }, []);

  const onClickProcessing = useCallback(() => {
    if (selectedAppList.length > 0) {
      dispatch(fetchInsightData({ appList: selectedAppList, country: selectedCountry }));
    }
  }, [selectedAppList, selectedCountry, dispatch, setParams, fetchInsightData]);

  return (
    // <!-- input 입력시 .active 추가 - 검색 레이어 노출 -->
    <div className={`search-app ${searchListFlag ? 'active' : ''}`}>
      <div className="app-sugg-search">
        <div className="search-box type-1">
          <label>
            <input
              type="text"
              className="search-ipt"
              placeholder="Search for any app by name or id"
              value={searchText}
              onChange={onChangeSearchTextHandler}
              onFocus={onFocusSearchTexthandler}
              onBlur={onBlurSearchTexthandler}
            />
          </label>
          {/* 위에서 active 처리할때 뜨는 li 리스트 보이는 부분 */}
          {searchResultList?.length > 0 && (
            <ul className={`search-list ${searchListFlag ? 'active' : ''}`}>
              {searchResultList.map((listObj, index) => (
                <li
                  key={index}
                  onClick={() => onClickAppListHandler(listObj)}
                  onMouseDown={() => onClickAppListHandler(listObj)}
                >
                  {listObj.hasOwnProperty('myApp') || listObj.hasOwnProperty('competitorApps') ? (
                    <span>
                      <b>{listObj.value}</b>
                    </span>
                  ) : (
                    <button style={{ width: 'inherit', height: 'inherit' }} type="button">
                      {listObj.type === gameProviderTypes.GooglePlayStore ? (
                        <p className="btn-ico-single android"></p>
                      ) : (
                        <p className="btn-ico-single app"></p>
                      )}
                      <img style={{ width: 'inherit', height: 'inherit' }} src={listObj.icon} />
                      <span>{listObj.title}</span>
                    </button>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="select-api">
          <ReactFlagsSelect
            selected={selectedCountry}
            onSelect={onChangeSelectCountry}
            countries={countriesArr}
            searchable={true}
          />
        </div>
        <label className="select">
          <select>
            <option>Saved List</option>
            <option>옵션 2</option>
            <option>옵션 3</option>
          </select>
        </label>
      </div>
      <div className="app-sugg-ranking">
        <ul className="chart-ranking-data">
          {selectedAppList.length > 0 && (
            <>
              {selectedAppList.map((appObj, index) => (
                <li key={`${appObj.appId}_${appObj.type}`}>
                  <div className="game-img">
                    <img src={appObj.icon} />
                  </div>
                  <div className="game-info">
                    <p className="game-tit">{appObj.title}</p>
                    <p className="game-desc">{appObj.developer}</p>
                  </div>
                  <button
                    type="button"
                    className="btn-ico-single app-del"
                    onClick={() => onClickAppListDelHandler(appObj)}
                  >
                    <span className="blind">삭제</span>
                  </button>
                </li>
              ))}
            </>
          )}
        </ul>
        <button
          type="button"
          className="btn pri"
          disabled={selectedAppList.length === 0 ? true : false}
          onClick={onClickProcessing}
        >
          Processing
        </button>
      </div>
    </div>
  );
};

export default SearchAppComponent;
